import React from 'react';
import { Link } from 'react-router-dom';
import { Content, Icon, Button } from 'rsuite';
import * as PERMISSIONS from '../../../constants/permissions/inventory';
import { viewAccess, modifyAccess } from '../../../helpers/permission';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';
import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';
import SearchPanel from '../../../components/inventory/SearchPanel';
import InventoryItemList from '../../../containers/inventory/ItemList';
import InventorySearchItem from '../../../containers/inventory/Search/Item';
import { inventoryCreateItemPath } from '../../Paths';

export default () => (
  <InventoryPageLayout>
    <AccessControl
      allowOnlyFor={viewAccess(PERMISSIONS.ITEM)}
      fallback={<AccessDenied />}
    >
      <PageHeader title="Items">
        <SearchPanel bordered>
          <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.ITEM)}>
            <Link to={inventoryCreateItemPath}>
              <Button appearance="primary">
                <Icon icon="plus-circle" /> Create New
              </Button>
            </Link>
          </AccessControl>
          <InventorySearchItem placeholder="Search name or description" />
        </SearchPanel>
      </PageHeader>
      <Content>
        <InventoryItemList />
      </Content>
    </AccessControl>
  </InventoryPageLayout>
);
